/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q8_QuestionInputs */

const en_home_faq_q8_question = /** @type {(inputs: Home_Faq_Q8_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I forgot my login details. What should I do?`)
};

const fr_home_faq_q8_question = /** @type {(inputs: Home_Faq_Q8_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'ai oublié mes informations de connexion. Que faire ?`)
};

/**
* | output |
* | --- |
* | "I forgot my login details. What should I do?" |
*
* @param {Home_Faq_Q8_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q8_question = /** @type {((inputs?: Home_Faq_Q8_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q8_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q8_question(inputs)
	return fr_home_faq_q8_question(inputs)
});